module.exports = __webpack_public_path__ + "static/img/边框14.5b9a0df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框14.svg
// module id = Sgt3
// module chunks = 2